




































































































import { defineComponent, computed, ref } from 'vue-demi';
import { Popup, Picker, RadioGroup, Radio } from 'nut';
import { SELECTION_BOX_POP_TYPE } from '../constants/business';
export default defineComponent({
  name: 'kdSelectionBox',
  components: {
    'nut-popup': Popup,
    'nut-picker': Picker,
    'nut-radio-group': RadioGroup,
    'nut-radio': Radio
  },
  props: {
    // 左边标题
    title: {
      type: String,
      default: ''
    },
    // 选择的文字
    selectedWord: [Number, String],
    // 选择的内容对应的id
    selectedId: {
      type: Number
    },
    // 选择的内容对应的key值
    valueKey: {
      type: String,
      default: ''
    },
    // 提示文字
    placeholder: {
      type: String,
      default: ''
    },
    // 是否有箭头
    isHasArrow: {
      type: Boolean,
      default: true
    },
    // 是否显示叉号
    isHasCloseIcon: {
      type: Boolean,
      default: true
    },
    // 是否能点击
    isCanClick: {
      type: Boolean,
      default: true
    },
    // 是否展示弹窗header
    isShowHeader: {
      type: Boolean,
      default: true
    },
    // 弹窗标题
    popTitle: {
      type: String,
      default: ''
    },
    // 弹窗类型
    popType: {
      type: Number,
      default: 0
    },
    // 弹窗数据类型
    dataList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 弹窗类型
    defaultIndex: {
      type: Number,
      default: 0
    },
    // 组件
    component: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(props: any, { emit }: any) {
    const show = ref<boolean>(false);
    const pickerCurrentChangeValue = ref<string | number>();
    // 选择的文字
    const computedSelectedWord = computed({
      get: () => props.selectedWord,
      set: value => {
        emit('update:selectedWord', value);
      }
    });
    const readOnlyWord = computed(() => props.selectedWord || props.placeholder);
    // 是否是cell类型弹窗
    const isCellPopType = computed(() => {
      [SELECTION_BOX_POP_TYPE.CELL_TITLE_POP, SELECTION_BOX_POP_TYPE.CELL_POP].includes(props.popType);
    });
    // 点击弹出选择弹窗或者跳转选择页面
    const selectContent = () => {
      // 不能点击
      if (!props.isCanClick) return;
      // 跳转选择页面
      if (props.popType === SELECTION_BOX_POP_TYPE.PAGE_JUMP) {
        emit('pageJump');
        return;
      }
      show.value = true;
    };
    // 关闭弹窗
    const closePop = () => {};
    // 单选框点击事件
    const radioClick = (id: number) => {
      emit('update:selectedId', id);
      emit('updateInfo', { key: props.valueKey, id: id });
      closePop();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pickerChange = (picker: any, values: string | number) => {
      pickerCurrentChangeValue.value = values;
    };
    const pickerConfirm = () => {
      const dataList = props.dataList;
      const selectedWord = pickerCurrentChangeValue.value || (dataList.length && dataList[0]);
      emit('update:selectedId', Number(selectedWord));
      emit('update:selectedWord', selectedWord);
      closePop();
    };
    const pickerCancel = () => {
      closePop();
    };
    // cell类型弹窗选择内容
    const cellSelect = (selectedWord: string, id: number) => {
      emit('update:selectedWord', selectedWord);
      emit('update:selectedId', id);
      emit('updateInfo', { key: props.valueKey, id: id });
      closePop();
    };
    return {
      SELECTION_BOX_POP_TYPE,
      show,
      pickerCurrentChangeValue,
      computedSelectedWord,
      readOnlyWord,
      selectContent,
      radioClick,
      closePop,
      isCellPopType,
      pickerChange,
      pickerConfirm,
      pickerCancel,
      cellSelect
    };
  }
});
